import { render, staticRenderFns } from "./led_screen.vue?vue&type=template&id=44d50717&scoped=true"
import script from "./led_screen.vue?vue&type=script&lang=js"
export * from "./led_screen.vue?vue&type=script&lang=js"
import style0 from "./led_screen.vue?vue&type=style&index=0&id=44d50717&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d50717",
  null
  
)

export default component.exports